import styled from 'styled-components';

// Machine-card do header (4o slot). Antes usava paleta legada
// (lightblue/black/white) + layout space-between com imagem opcional
// (so > 1285px), o que em telas menores deixava um box branco vazio
// com o nome de um lado e "Ver mais" do outro — a "caixa quebrada"
// do design antigo. Agora: badge + label/nome empilhados + botao,
// tudo em tokens --cco-* (consistente com AplicacaoInfo ao lado).
export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  height: 100%;
  padding: 0 14px;
  box-sizing: border-box;
  background: var(--cco-surface);
  border: 1px solid var(--cco-line);
  border-radius: 10px;
`;

// Badge azul-soft com inset hairline — mesmo padrao do Badge cyan do
// AplicacaoInfo, trocando a cor pra diferenciar os dois cards do header.
export const Badge = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 10px;
  flex: none;
  background: var(--cco-blue-soft);
  color: var(--cco-blue);
  box-shadow: inset 0 0 0 1px var(--cco-blue-soft);
  display: grid;
  place-items: center;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
  flex: 1;
`;

export const Label = styled.span`
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--cco-ink-mute);
  line-height: 1;
`;

export const Name = styled.div`
  font-size: 14px;
  font-weight: 800;
  color: var(--cco-ink);
  letter-spacing: 0.02em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// Botao "Ver mais" — ghost com hairline; preenche azul no hover.
export const MoreButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex: none;
  padding: 6px 10px;
  border-radius: 8px;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
  border: 1px solid var(--cco-line-strong);
  background: transparent;
  color: var(--cco-blue);
  transition: background 150ms ease, color 150ms ease, border-color 150ms ease;

  svg {
    width: 14px;
    height: 14px;
  }

  :hover {
    background: var(--cco-blue);
    color: #fff;
    border-color: var(--cco-blue);
  }
`;
